import { map, isArray, castArray, isString } from 'lodash-es'

const getValue = (data) => {
  const items = map(data, (v) => {
    if (isString(v)) {
      return v
    }
    return (v && v.title) || '未找到指标'
  })
  return items.join('-')
}

const transformer = function (origin, defs) {
  const arredVal = origin ? castArray(origin) : []
  const isMultiDeep = arredVal.some((item) => isArray(item))
  let value
  if (isMultiDeep) {
    value = map(arredVal, (line) => {
      return getValue(line)
    })
  } else {
    value = getValue(arredVal)
  }

  return {
    render: 'text',
    origin,
    value,
    defs: { 'inline-nowrap': true, ...defs },
  }
}

export default transformer
